import React from 'react'
import { FormControlLabel, Checkbox } from '@material-ui/core'
import PropTypes from 'prop-types'


export default function CustomCheckbox(props) {
  const { label, checked, change, className } = props

  return (
    <FormControlLabel
      classes={{
        root: className ? className : ''
      }}
      control={
        <Checkbox
          checked={checked}
          onChange={change}
          color='primary' />
      }
      label={label} />
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  className: PropTypes.string
}

